(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coast-pro-mr"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-coast-pro-story]').forEach(function(story){if(story.dataset.coastBound)return;story.dataset.coastBound='true';var rail=story.querySelector('[data-coast-rail]');if(!rail)return;function move(direction){rail.scrollBy({left:direction*rail.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}story.querySelector('[data-coast-prev]').addEventListener('click',function(){move(-1)});story.querySelector('[data-coast-next]').addEventListener('click',function(){move(1)});rail.addEventListener('keydown',function(event){if(event.key==='ArrowRight'){event.preventDefault();move(1)}if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fatboy-preorder-notice"] && !Shopify.designMode) return;
  try {
    (function(){
'use strict';
function init(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.closest('form');if(!form)return;
 let data;try{data=JSON.parse(root.querySelector('[data-fb-preorder-data]').textContent);}catch(e){return;}
 const rows=new Map(data.variants.map(v=>[String(v.id),v])),labels=data.labels,cart=root.dataset.mode==='cart';
 let current=root.dataset.current,blocked=false,controlled=false;
 const state=v=>v&&v.state&&v.state!=='stock'&&v.state!=='restricted'&&Date.now()>=v.expires*1000?'stale':v?.state||'';
 const message=v=>state(v)==='stale'?labels.stale:v?.message||'';
 const isBlocked=s=>['restricted','stale','pending'].includes(s);
 function selected(){const input=form.querySelector('[name="id"]');return rows.get(String(input?.value||current));}
 function refresh(){
  if(cart){blocked=false;root.querySelectorAll('[data-fb-preorder-line]').forEach(line=>{const v=rows.get(line.dataset.fbPreorderLine);line.querySelector('span').textContent=message(v);if(isBlocked(state(v)))blocked=true;});form.classList.toggle('fb-preorder-guard',blocked);form.querySelectorAll('[name="checkout"]').forEach(b=>{if(blocked){b.dataset.fbBlocked='true';b.disabled=true;}else if(b.dataset.fbBlocked){b.disabled=false;delete b.dataset.fbBlocked;}});return;}
  const v=selected(),s=state(v),status=root.querySelector('[data-fb-preorder-status]'),property=root.querySelector('[data-fb-preorder-property]');blocked=isBlocked(s);
  status.textContent=message(v);status.hidden=!s;property.disabled=s!=='preorder';property.value=s==='preorder'?message(v):'';
  form.classList.toggle('fb-preorder-guard',!!s&&s!=='stock');
  const button=form.querySelector('[name="add"],[data-add-to-cart]');
  if(button&&(s||controlled)){if(s){button.disabled=blocked||!v.available;const label=button.querySelector('[data-add-to-cart-text]')||button;label.textContent=blocked?labels.enquiry:s==='preorder'?labels.preorder:labels.add;controlled=true;}else controlled=false;}
  const stock=form.querySelector('#variantstock');if(stock&&s)stock.textContent=message(v);
  const panel=form.closest('.product-section')?.querySelector('[data-fm-stock-enquiry] [data-fm-stock-status]');if(panel&&s)panel.textContent=message(v);
 }
 form.addEventListener('change',()=>queueMicrotask(refresh));
 (form.closest('.product-section')||document).addEventListener('variantChange',e=>{if(!cart&&e.detail?.variant){current=String(e.detail.variant.id);setTimeout(refresh,0);}});
 form.addEventListener('submit',e=>{refresh();if(blocked&&(!cart||e.submitter?.name!=='update')){e.preventDefault();e.stopImmediatePropagation();root.scrollIntoView({block:'center',behavior:'smooth'});}},true);
 form.addEventListener('click',e=>{if(cart&&e.target.closest('[name="checkout"],a[href*="/checkout"]')){refresh();if(blocked){e.preventDefault();e.stopImmediatePropagation();}}},true);
 refresh();setTimeout(refresh,0);setInterval(refresh,30000);
}
function scan(){document.querySelectorAll('[data-fb-preorder-notice]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
document.addEventListener('shopify:section:load',scan);document.addEventListener('cart:updated',scan);document.addEventListener('cart:build',scan);
new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
